import { useInfiniteQuery } from "@tanstack/react-query";

import getProductsByCategory from "../api/getProductsByCategory";

const useGetProductsByCategory = (category: string) => {
  const {
    data: getProductsByCategoryData,
    isLoading: isLoadingGetProductsByCategory,
    isError: isErrorGetProductsByCategory,
    refetch: refetchGetProductsByCategoryData,
    fetchNextPage: fetchNextPageGetProductsByCategory,
    hasNextPage: hasNextPageGetProductsByCategory,
    isFetchingNextPage: isFetchingNextPageGetProductsByCategory,
    isFetching: isFetchingGetProductsByCategory,
  } = useInfiniteQuery({
    queryKey: ["getProductsByCategory", category],
    queryFn: ({ pageParam = 1 }) =>
      getProductsByCategory({ category, pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.nextPage <= lastPage.totalPages ? lastPage.nextPage : undefined,
    refetchOnWindowFocus: false,
    enabled: !!category,
  });

  return {
    isLoadingGetProductsByCategory,
    getProductsByCategoryData,
    isErrorGetProductsByCategory,
    refetchGetProductsByCategoryData,
    fetchNextPageGetProductsByCategory,
    hasNextPageGetProductsByCategory,
    isFetchingNextPageGetProductsByCategory,
    isFetchingGetProductsByCategory,
  };
};

export default useGetProductsByCategory;
